import TwoColumnGrid from "./TwoColumnGrid";

export default {
  TwoColumnGrid
}